import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ReactGA from 'react-ga4';
import Api from "../../../lib/Api";
import Ads from "../../../lib/Ads";

function FindBikeButton({ item, className, traject, source }) {
  const [t] = useTranslation("result");
  const [bikeAd, setBikeAd] = useState(null);

  useEffect(() => {
    (async function () {
      try {
        if (item && item["bike_model"] && item["bike_model"]["bike_id"]) {
          const bikedata = await Ads.fetchAds(
            item["bike_model"]["bike_id"],
            "store_locator"
          );
          if (bikedata) {
            setBikeAd(bikedata);
          }
        }
      } catch (e) {
        console.error(e);
      }
    })();
  }, [item]);

  const goToStore = (event) => {
    if (bikeAd.bike && bikeAd.campaign && bikeAd.position) {
      const body = {
        position_id: bikeAd.position.id,
        campaign_id: bikeAd.campaign.id,
        bike_id: bikeAd.bike.id,
        type: "click",
        url_sent_to: bikeAd.bike && bikeAd.bike.url,
        url_sent_from: window.location.href,
        // lead_generated
        source: source || "unspecified",
      };

      const url = `/campaign/result`;

      console.log(body);

      Api.post(url, body)
        .then((response) => {
          console.log(response.data);
        })
        .catch((error) => {
          alert(error);
        });

      ReactGA.event({
        action: "click",
        category: "find_store_" + traject,
        label: item.bike_model.brand + " " + item.bike_model.model,
        value: item.bike_model.price,
      });

      event.stopPropagation();
      const storeUrl = bikeAd.bike && bikeAd.bike.url;

      window.open(storeUrl, "_blank");
    }
  };

  // const getStoreForBrand = (brand) => {
  //   // get store URL for brand
  //   let brandUrl = "";
  //   switch (brand) {
  //     case "BMC":
  //       brandUrl = "https://www.bmc-switzerland.com/stockists";
  //       break;
  //     case "Cannondale":
  //       brandUrl = "https://www.cannondale.com/nl-nl/find-a-dealer";
  //       break;
  //     case "Canyon":
  //       brandUrl = "https://www.canyon.com/nl/";
  //       break;
  //     case "CUBE":
  //       brandUrl = "https://www.cube.eu/nl/dealer-search/";
  //       break;
  //     case "Felt":
  //       brandUrl = "https://eu-en.feltbicycles.com/pages/dealers";
  //       break;
  //     case "Focus":
  //       brandUrl = "https://www.focus-bikes.com/int/store-locator/";
  //       break;
  //     case "Merida":
  //       brandUrl = "https://www.merida.nl/dealers/";
  //       break;
  //     case "Orbea":
  //       brandUrl = "https://www.orbea.com/be-nl/dealers/?country=NL";
  //       break;
  //     case "Scott":
  //       brandUrl = "https://www.scott-sports.com/nl/en/dealers/locator";
  //       break;
  //     case "Specialized":
  //       brandUrl = "https://www.specialized.com/nl/nl/store-finder";
  //       break;
  //     case "Stevens":
  //       brandUrl =
  //         "https://www.stevensbikes.de/2019/index.php?cou=NL&lang=nl_NL&dealermap";
  //       break;
  //     case "Trek":
  //       brandUrl = "https://www.trekbikes.com/nl/nl_NL/store-finder/";
  //       break;
  //     default:
  //       break;
  //   }

  //   return brandUrl;
  // };

  return (
    <>
      {bikeAd && (
        <button className={className} onClick={(event) => goToStore(event)}>
          {t("Vind winkel")}
        </button>
      )}
    </>
  );
}

export default FindBikeButton;
